// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"b2c15d9bb80b5ebc8b8c","223":"96f3f948480fdc4fda1c","691":"30fc7012c0b26d78d239","843":"38e0296ef7fc9d09bef8"}[chunkId] + ".js";
};